export class Organization {
    id: string;
    name: string;
    name_en: string;
    vat_sts: string;
    def_org: string;
    tax_number: string;
    main_currency: string;
    tel:string;
    address:string;
    address_en:string;
    fax:string;
    email:string;
    website:string;
    system_logo: string;
    reports_logo: string;


    creation_user: string;
    creation_ip: string;
    created_at: string;

    last_update_user:string;
    last_update_ip:string;
    on_behalf_of:string;
    last_on_behalf_of:string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/organization/organization.ts